import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"

// Assets
import userProfileStyles from "./userProfileStyles.jsx"

// Services
import {primaryColor} from "../../assets/jss/material-dashboard-pro-react";
import Table from "../../components/Table";
import ReactTimeAgo from "react-time-ago";
import {connect} from "react-redux";
import {deviceService} from "../../_services";
import {CloseTwoTone} from "@material-ui/icons";
import {REFRESH_RATES, getRefreshRate} from "../../_constants/index.js";
import {beautify_name} from "../helpers.js";



class DockingImplementDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.getInitialState()
  }

  getInitialState() {
    return {
      /** @type {import('../../_services/device.service.js').DockingImplementStateV2 | null} Actual state of the device */
      device_state_v2: null,
    }
  }

  componentDidMount() {
    this._is_mounted = true
    const {device_serial} = this.props
    this.refresh(device_serial)
  }

  componentWillUnmount() {
    clearTimeout(this.deviceStateRefresher)
    this._is_mounted = false
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.device_serial !== this.props.device_serial) {
      clearTimeout(this.deviceStateRefresher)
      //Clear state of previous device.
      this.setState(this.getInitialState())
      this.refresh(this.props.device_serial)
    }
  }

  refresh(device_serial) {
    this.getDeviceState(device_serial)
  }

  getDeviceState(device_serial) {
    deviceService.getDeviceStateV2(device_serial).then(state => {
      this.setState({device_state_v2: state})
    }).then(() => {
      // Auto-fetch the device state when on the device detail page
      // to get updated state information as this is can change frequently
      if (this._is_mounted) {
        this.deviceStateRefresher = setTimeout(this.getDeviceState.bind(this, device_serial), getRefreshRate(REFRESH_RATES.MEDIUM))
      }
    })
  }

  render() {
    const {device_serial, device_name} = this.props
    const {device_state_v2} = this.state

    if (!device_state_v2) {
      return renderLoadingState(device_serial, device_name)
    }

    return (
      <GridContainer>
        {renderGeneralCard(device_serial, device_name, device_state_v2)}
        {renderStateCard(device_state_v2)}
        {renderConnectedDevicesCard(device_state_v2)}
      </GridContainer>
    )
  }
}

/**
 * @param {string} device_serial
 * @param {string} device_name
 * @returns {JSX.Element}
 */
function renderLoadingState(device_serial, device_name) {
  return (
    <GridContainer>
      <GridItem xs={12} md={12}>
        <h5 style={{color: primaryColor}}>General</h5>
        <Table
          color={"primary"}
          tableData={[
            [<b>Serial Number</b>, device_serial],
            [<b>Name</b>, <div>{device_name}</div>],
            ["", ""]
          ]}/>
        <p><CloseTwoTone style={{color: "rgb(231,92,92)"}}/> Device state not available yet.</p>
      </GridItem>
    </GridContainer>
  )
}

/**
 * @param {string} device_serial
 * @param {string} device_name
 * @param {import('../../_services/device.service.js').DockingImplementStateV2} device_state_v2
 * @returns {JSX.Element}
 */
function renderGeneralCard(device_serial, device_name, device_state_v2) {
  return (
    <GridItem xs={12} md={6}>
      <h5 style={{color: primaryColor}}>General</h5>
      <Table
        color={"primary"}
        tableData={[
          [<b>Serial Number</b>, device_serial],
          [<b>Name</b>, <div>{device_name}</div>],
          [<b>Device Type</b>, device_state_v2.device_type],
          ["", ""]
        ]}/>
    </GridItem>
  )
}

/**
 * @param {import('../../_services/device.service.js').DockingImplementStateV2} device_state_v2
 * @returns {JSX.Element}
 */
function renderStateCard(device_state_v2) {
  return (
    <GridItem xs={12} md={6}>
      <h5 style={{color: primaryColor}}>Last Known State</h5>
      <Table
        color={"primary"}
        tableData={[
          [
          <b>Last Connected</b>,
          <span>
            {new Date(Date.parse(device_state_v2.timestamp)).toLocaleString('nl-BE')}
            &nbsp;&nbsp;(&nbsp;<ReactTimeAgo date={device_state_v2.timestamp} locale="en-UK"/>&nbsp;)
          </span>
        ],
        [<b>Connection status</b>,
            <span style={{color: device_state_v2.is_live ? "rgb(100,169,68)" : 'rgb(255,0,0)'}}>
              {device_state_v2.is_live ? "Online" : "Offline"}
            </span>
        ],
          [<b>Task</b>, beautify_name(device_state_v2.state)],
          [<b>Error Code</b>, device_state_v2.error_code || "-"],
          ["", ""]
        ]}/>
    </GridItem>
  )
}

/**
 * @param {import('../../_services/device.service.js').DockingImplementStateV2} device_state_v2
 * @returns {JSX.Element}
 */
function renderConnectedDevicesCard(device_state_v2) {
  const connected_devices = device_state_v2.connected_devices || []

  const IMPLEMENT_TYPES = ["UVP01", "UVP02", "UVP04", "UVP06", "IDK01", "SPR01", "SCT01", "BUG01"]
  const HARDWARE_TYPES = ["DBD01", "DIL01", "DSS01", "DFB01"]

  const implements_ = connected_devices.filter(d => d && IMPLEMENT_TYPES.includes(d.device_type))
  const hardware = connected_devices.filter(d => d && HARDWARE_TYPES.includes(d.device_type))
  const unknown = connected_devices.filter(d => d && d.device_type === "unknown")

  return (
    <GridItem xs={12} md={12}>
      <h5 style={{color: primaryColor}}>Connected Devices</h5>
      {renderDeviceTable("Implements", implements_)}
      {renderDeviceTable("Hardware", hardware)}
      {unknown.length > 0 && renderDeviceTable("Unknown", unknown)}
    </GridItem>
  )
}

/**
 * @param {string} title
 * @param {Array<{serial_number: string | null, device_type: string}>} devices
 * @returns {JSX.Element}
 */
function renderDeviceTable(title, devices) {
  return (
    <div style={{marginBottom: "16px"}}>
      <h6 style={{color: primaryColor}}>{title} ({devices.length})</h6>
      {devices.length === 0 ? (
        <p>No {title.toLowerCase()} connected.</p>
      ) : (
        <Table
          color={"primary"}
          tableData={[
            [<b>Serial Number</b>, <b>Type</b>],
            ...devices.map(device => [
              device.serial_number || "-",
              device.device_type
            ]),
            ["", ""]
          ]}/>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  const {device_serial, all_devices} = state.device_fleet

  let device_name = ""
  all_devices.forEach((device) => {
    if (device["serial"] === device_serial) {
      device_name = device["name"]
    }
  })

  return {
    device_serial, device_name
  }
}


export default withStyles(userProfileStyles)(connect(mapStateToProps)(DockingImplementDetail))
